export const mitigationRoomsCapability = 'mitigation.rooms.v1';
export const mitigationInsuranceClaimsReadinessProviderId = 'mitigation.server.insurance-claims-readiness';
//# sourceMappingURL=mitigation-insurance-claims-readiness.contract.js.map